import { Component, OnInit, OnDestroy, OnChanges } from '@angular/core';
import { MenuService } from '../../services/menu.service';
import { MenuModel } from '../../models/menu.model';
import { Observable, Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { PermissionModel } from '../../models/permission.model';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit, OnDestroy {

  authSubscription: Subscription;
  menuSubscription: Subscription;
  menu: MenuModel;
  permissions: PermissionModel[];

  constructor(
    private menuService: MenuService,
    private authService: AuthService
  ) { }

  ngOnInit() {

    this.authSubscription = this.authService.getAuthentication().subscribe(result => {
      if (result) {
        if (result.Anagrafica != undefined && result.Anagrafica != null) {
          let a = new PermissionModel();
          a.Description = "a";
          a.PermissionId = 1;
          a.PlantCode = "";
          this.permissions = [];
          this.permissions.push(a);

          if(result.Anagrafica.ruolo == 2|| result.Anagrafica.ruolo ==1){
            let b = new PermissionModel();
            b.Description = "a";
            b.PermissionId = 2;
            b.PlantCode = "";
            this.permissions.push(b);
          }

          this.menuSubscription = this.menuService.getMenu().subscribe(result => {
            this.menu = null;
            this.menu = result;
          });

        } else {
          this.menu = null;
          this.permissions = [];
        }
      } else {
        this.menu = null;
        this.permissions = [];
      }
    });

  }

  ngOnDestroy() {
    this.menuSubscription.unsubscribe();
    this.authSubscription.unsubscribe();
  }

}
